// ----------------- SET SELECTED PROGRAM -----------------
export const SET_SELECTED_PROGRAM = 'SET_SELECTED_PROGRAM';

// ----------------- CLEAR SELECTED PROGRAM -----------------
export const CLEAR_SELECTED_PROGRAM = 'CLEAR_SELECTED_PROGRAM';
